import React from 'react';
import { ProductVariant } from '../../../../../model/product';

export function VariantCell({
  variant,
  isEvent,
}: {
  variant?: Partial<ProductVariant>;
  isEvent?: boolean;
}): JSX.Element {
  if (variant === undefined || variant === null) {
    return <span> - </span>;
  }

  return (
    <div className="detail-block">
      <span>{variant.description}</span>
      {isEvent && <span className="secondary-detail">{variant.physical ? 'HardTicket' : 'Online'}</span>}
    </div>
  );
}
